import { } from "jquery"
import { inspect } from "util"
import { Asset, Tablet, QueryAsset, PagedListResult, Dict, QueryAssetOrderBy, AssetLoanHistory, ModelResult, AssetLoan } from "../api/model"
import { AssetApi, AssetLoanApi, FileApi } from "../api/api"
import { UiUtils, JqElm, GeneralElementCreator } from "./ui"
import { AssetBasicDataProvider } from "./asset_page_base"
import { AssetSearchBlock, AssetSearchBlockBuilder, QueryResultCallback } from "./asset_search_block"
import { Pagination } from "../utils/pagination"
import { PaginationUi } from "./pagination_ui"
import { formatDate } from "../utils/date"
import { cleanProperties } from "../utils/core"
import { HouseKeeperHelper } from "./house_keeper_helper"
import { AssetLoanPageBase } from "./asset_loan_base"

/**
 * Main class to handle "**CreateAssetPage**" page UI elements, events, and actions
 */
export class AssetLoanPage extends AssetLoanPageBase {

    private assetItemElmCreator = new AssetItemElementCreator()
    private loanCartItemElmCreator = new LoanCartItemElementCreator()
    private loanResultItemElmCreator = new LoanResultItemElementCreator()
    private searchPanel: JqElm
    private listTableElm: JqElm
    private cartTableElm: JqElm
    private static readonly DefaultMaxCount = 10
    private static readonly DefaultBucketSize = 5
    protected cartMap: Dict<Asset> = {}

    private pagination = new Pagination(AssetLoanPage.DefaultMaxCount, AssetLoanPage.DefaultBucketSize)
    private queryAsset: QueryAsset = {
        maxCount: AssetLoanPage.DefaultMaxCount,
        orderBy: "displayId",
        orderByDescending: true
    }
    assetSearchBlock: AssetSearchBlock
    private paginationUi: PaginationUi

    constructor(
        assetApi: AssetApi,
        assetLoanApi: AssetLoanApi,
        assetBasicDataProvider: AssetBasicDataProvider,
        fileApi: FileApi,
        houseKeeperHelper: HouseKeeperHelper

    ) {
        super(assetApi, assetLoanApi, houseKeeperHelper, fileApi, assetBasicDataProvider)

        this.assetSearchBlock = new AssetSearchBlockBuilder(
            assetApi, assetBasicDataProvider, true, this.assetQueryResultCallback.bind(this)
        )
            .withQueryAsset(this.queryAsset)
            .withRefineAssetQuery(queryAsset => queryAsset.type = 'normal')
            .withAssetMap(this.assetMap)
            .withPagination(this.pagination)
            .build()
    }

    private assetQueryResultCallback(e: any, result: PagedListResult<Asset>) {
        if (e != null) {
            //console.log("Error for asset query:%s", e)
        } else {
            this.toggleListElms(true)
            this.scrollToList()
            //console.log("Search result:%s", inspect(result))
            this.updateAssetElms(result)
        }
    }

    private scrollToList() {
        $('html, body').animate({
            scrollTop: $("#section_query").offset().top - 120
        }, 10)
    }

    initSearchBlock() {
        this.assetSearchBlock.load()
    }

    initPagination() {
        this.paginationUi = new PaginationUi($('#asset_list_pagination'), this.pagination, (offset) => {
            this.queryAsset.offset = offset
            this.queryAndFillAssets()
        })
    }

    async queryAndFillAssets(): Promise<void> {
        const queryAssetResp = await this.assetSearchBlock.queryAssets()
        this.updateAssetElms(queryAssetResp)
    }

    private updateAssetElms(queryAssetResp: PagedListResult<Asset>) {
        this.fillAssetListData(queryAssetResp.data)
    }

    private fillAssetListData(assets: Array<Asset>) {
        this.paginationUi.refresh()
        $(`.${this.assetItemElmCreator.classId}`).remove()
        assets.forEach(asset => {
            //console.log("Fill asset item:%s", inspect(asset))
            const elm = this.appendAssetItemElm(asset.id.toString())
            this.fillAssetElmData(asset, elm)
        })
    }

    listenRemoveCartClick() {
        $(document).on('click', `.${this.loanCartItemElmCreator.classId} .rm_cart_btn`, e => {
            e.preventDefault()
            const el = $(e.target)
            const assetId = el.data('id')
            el.parents(`.${this.loanCartItemElmCreator.classId}`).remove()
            const asset = this.assetMap[assetId]
            delete this.cartMap[assetId]
            if (Object.keys(this.cartMap).length == 0) {
                this.toggleCartElms(false)
            }
        })
    }

    private toggleCartElms(show: boolean) {
        this.cartTableElm.toggle(show)
        if (this.signatureStatus != 'none') {
            this.gotoStep3Elm.toggle(show)
        }
    }

    private toggleListElms(show: boolean) {
        this.listTableElm.toggle(show)
    }

    listenAddCartClick() {
        $(document).on('click', `.${this.assetItemElmCreator.classId} .add_cart_btn`, e => {
            e.preventDefault()
            const el = $(e.target)
            const assetId = el.data('id')
            const asset = this.assetMap[assetId]
            this.notifyAdded()
            if (this.cartMap[assetId] != null) {
                return
            }
            this.toggleCartElms(true)
            this.cartMap[assetId] = asset
            const cartElm = this.appendCartItemElm(asset.id.toString())
            this.fillCartElmData(asset, cartElm)
        })
    }

    listenProcessLoanClick() {
        $('#create_loan_btn').click(e => {
            e.preventDefault()
            //this.takePictures()
            this.processLoan()
        })
    }
    private takePictures() {
        //console.log("Do take pic:%s", this.webCamStatus)
        const Webcam = (<any>window).Webcam
        Webcam.set({
            width: 230,
            height: 150,
            dest_width: 230,
            dest_height: 150,
            image_format: 'jpeg',
            jpeg_quality: 90,
            fps: 45
        });
        const that = this

        if (that.lockPictureButton == false) {
            $("#manualPicture").button("loading");
            that.lockPictureButton = true;
        }
        else {
            return;
        }

        if (this.webCamStatus) {
            Webcam.snap(function (dataUri: string) {
                $("#imgCapture").attr("alt", "上傳中...").attr("src", "");
                (<any>that.uploadTask).getTask("webcam").upload(dataUri).then(function (snapshot: object) {
                    //上傳成功 setTimeout防止連續拍照(firebase不允許短時間內多次上傳)
                    setTimeout(function () {
                        $("#imgCapture").attr("src", dataUri).attr("alt", "");
                        $("#theEnd").show();
                        $("#manualPicture").button("reset");
                        that.lockPictureButton = false;
                    }, 500);
                }).catch(function () {
                    //上傳失敗 setTimeout防止連續拍照(firebase不允許短時間內多次上傳)
                    setTimeout(function () {
                        $("#imgCapture").attr('src', '').attr("alt", "上傳失敗，請嘗試重新拍照");
                        $("#manualPicture").button("reset");
                        that.lockPictureButton = false;
                    }, 500);
                });
            })
        }
        else {
            //console.log("No pc")
            $(".webcamPhotoDiv .loading").hide()
            $("#theEnd").show()
        }
    }

    private async processLoan(): Promise<void> {
        const assetIdsToQuery: Array<number> = []
        const histories = $(`.${this.loanCartItemElmCreator.classId}`).toArray().map($).map(elm => {
            const id = <number>elm.data('id')
            if (assetIdsToQuery.indexOf(id) == -1) {
                assetIdsToQuery.push(id)
            }
            const q = <number>elm.find('[name=quantity]').val()
            return {
                assetId: id,
                quantity: q
            }
        });

        var fileName;
        var webcamUri;
        var handwriteUri;
        var uploadSuccess = false;

        await (<any>this.uploadTask).done().then(function (result: any) {
            fileName = result["fileName"];
            webcamUri = result["uri"]["webcam"];
            handwriteUri = result["uri"]["handwrite"];
            uploadSuccess = true;
        }).catch(function (status: string) {
            if (status != "cancel")
            {
                bootbox.alert("執行失敗，請洽技術中心");
            }
            uploadSuccess = false;
        });

        if(!uploadSuccess)
        {
            return;
        }

        try {
            const createResult = await this.assetLoanApi.create({
                tabletId: this.currentTablet.id,
                loanHistories: histories,
                signature: handwriteUri != null ? fileName : null,
                picture: webcamUri != null ? fileName : null,
                webcamUri: webcamUri,
                handwriteUri: handwriteUri
            })
            const assets = (await this.assetApi.query({ ids: assetIdsToQuery, maxCount: 100 })).data

            //console.log("Create result:%s", inspect(createResult, false, 5))
            $(`.${this.loanResultItemElmCreator.classId}`).remove()
            createResult.data.loanHistories.forEach(history => {
                const asset = assets.find(it => it.id == history.assetId)
                const rtElm = this.appendLoanItemElm(asset.id.toString())
                this.fillLoanElmData(asset, history, rtElm)
            })
            this.toggleFinalElms(true)
            $('.date_success').text(formatDate(createResult.data.createdAt))
            this.gotoStep(3)
            this.resetStep2(assets)
        } catch (e) {
            UiUtils.alertIfClientError(e)
        }
    }

    private resetStep2(assets: Array<Asset>) {
        cleanProperties(this.assetMap)
        assets.forEach(asset => this.assetMap[asset.id] = asset)
        cleanProperties(this.cartMap)
        $(`.${this.assetItemElmCreator.classId}`).remove()
        $(`.${this.loanCartItemElmCreator.classId}`).remove()
        this.toggleCartElms(false)
        this.toggleListElms(false)
        this.assetSearchBlock.cleanFilterUi()
        if (this.signatureStatus == 'ok') {
            this.processSignatureResult('')
        }
        //$("#imgCapture").attr('src', '')
        //$("#webcamPhoto").hide()
    }

    private appendCartItemElm(id: string): JqElm {
        const templateData = {
            id: id
        }
        const elm = this.loanCartItemElmCreator.createJqElm(templateData)
        elm.appendTo($(this.loanCartItemElmCreator.tmplElmId).parent())
        return elm
    }

    private appendLoanItemElm(id: string): JqElm {
        const templateData = {
            id: id
        }
        const elm = this.loanResultItemElmCreator.createJqElm(templateData)
        elm.appendTo($(this.loanResultItemElmCreator.tmplElmId).parent())
        return elm
    }

    private appendAssetItemElm(id: string): JqElm {
        const templateData = {
            id: id
        }
        const elm = this.assetItemElmCreator.createJqElm(templateData)
        elm.appendTo($(this.assetItemElmCreator.tmplElmId).parent())
        return elm
    }

    private fillLoanElmData(asset: Asset, history: AssetLoanHistory, assetElm: JqElm) {
        const id = asset.id
        this.elmById(id, 'item_displayId').text(asset.displayId)
        this.elmById(id, "item_name").text(asset.name)
        this.elmById(id, 'item_quantity').text(history.quantity)
        this.elmById(id, 'item_communityAssignId').text(asset.communityAssignId != null ? asset.communityAssignId : '')
        const catName = this.assetBasicDataProvider.getCategoryName(asset.categoryId)
        this.elmById(id, 'item_category').text(catName)
        this.elmById(id, "item_area").text(this.assetBasicDataProvider.getAreaName(asset.areaId))
        this.elmById(id, "item_status").text(this.statusNameMap[asset.status])
        if (asset.type == 'fixed') {
            this.elmById(id, 'item_type').text('固定資產')
        } else {
            this.elmById(id, 'item_type').text('一般資產')
            if (asset.facilityIds != null && asset.facilityIds.length != 0) {
                this.elmById(id, 'item_facilityEnable').show()
                const facilityIds = new Set(asset.facilityIds)
                const facilityNames = this.assetBasicDataProvider.facilities.filter(it => facilityIds.has(it.id)).map(it => it.name)
                this.elmById(id, 'item_facilities').text(facilityNames.join(","))
            } else {
                this.elmById(id, 'item_facilityEnable').hide()
                this.elmById(id, 'item_facilities').text('')
            }
        }
        this.elmById(id, 'item_guestLoanable').toggle(asset.guestLoanable)
    }

    private fillCartElmData(asset: Asset, assetElm: JqElm) {
        const id = asset.id
        this.elmById(id, 'item_displayId').text(asset.displayId)
        this.elmById(id, "item_name").text(asset.name)
        let remaining = asset.quantity - asset.loan
        const quantityElm = this.elmById(id, null, 'quantity')
        for (let i = 1; i <= remaining; i++) {
            const iName = i.toString()
            quantityElm.append(UiUtils.options(iName, iName))
        }
        this.elmById(id, 'item_communityAssignId').text(asset.communityAssignId != null ? asset.communityAssignId : '')
        const catName = this.assetBasicDataProvider.getCategoryName(asset.categoryId)
        this.elmById(id, 'item_category').text(catName)
        this.elmById(id, "item_area").text(this.assetBasicDataProvider.getAreaName(asset.areaId))
        this.elmById(id, "item_status").text(this.statusNameMap[asset.status])
        if (asset.type == 'fixed') {
            this.elmById(id, 'item_type').text('固定資產')
        } else {
            this.elmById(id, 'item_type').text('一般資產')
            if (asset.facilityIds != null && asset.facilityIds.length != 0) {
                this.elmById(id, 'item_facilityEnable').show()
                const facilityIds = new Set(asset.facilityIds)
                const facilityNames = this.assetBasicDataProvider.facilities.filter(it => facilityIds.has(it.id)).map(it => it.name)
                this.elmById(id, 'item_facilities').text(facilityNames.join(","))
            } else {
                this.elmById(id, 'item_facilityEnable').hide()
                this.elmById(id, 'item_facilities').text('')
            }
        }
        this.elmById(id, 'item_guestLoanable').toggle(asset.guestLoanable)
    }

    private fillAssetElmData(asset: Asset, assetElm: JqElm) {
        const id = assetElm.data('id')
        this.elmById(id, 'item_displayId').text(asset.displayId)
        this.elmById(id, "item_name").text(asset.name)
        if (asset.loan > 0) {
            let remaining = asset.quantity - asset.loan
            this.elmById(id, "item_remaining").text(`現有 ${remaining} 個`).show()
        }
        this.elmById(id, "item_quantity").text(`原有 ${asset.quantity} 個`)
        this.elmById(id, 'item_communityAssignId').text(asset.communityAssignId != null ? asset.communityAssignId : '')
        const catName = this.assetBasicDataProvider.getCategoryName(asset.categoryId)
        this.elmById(id, 'item_category').text(catName)
        this.elmById(id, "item_area").text(this.assetBasicDataProvider.getAreaName(asset.areaId))
        this.elmById(id, "item_status").text(this.statusNameMap[asset.status])
        if (asset.type == 'fixed') {
            this.elmById(id, 'item_type').text('固定資產')
        } else {
            this.elmById(id, 'item_type').text('一般資產')
            if (asset.facilityIds != null && asset.facilityIds.length != 0) {
                this.elmById(id, 'item_facilityEnable').show()
                const facilityIds = new Set(asset.facilityIds)
                const facilityNames = this.assetBasicDataProvider.facilities.filter(it => facilityIds.has(it.id)).map(it => it.name)
                this.elmById(id, 'item_facilities').text(facilityNames.join(","))
            } else {
                this.elmById(id, 'item_facilityEnable').hide()
                this.elmById(id, 'item_facilities').text('')
            }
        }
        this.elmById(id, 'item_guestLoanable').toggle(asset.guestLoanable)
        if (asset.status == 'inStock') {
            this.elmById(id, 'add_cart_btn').show()
        }
    }

    listenSortChange() {
        const sortableElms = $('[class^=head_sort]')
        sortableElms.click(e => {
            const elm = $(e.currentTarget)
            //Get current sort status
            const reverseSorted = elm.hasClass('sorttable_sorted_reverse')
            const sorted = elm.hasClass('sorttable_sorted')
            //Clean all sort status
            sortableElms.removeClass('sorttable_sorted_reverse').removeClass('sorttable_sorted')
            //Get sort name
            const sortName = [
                'head_sort_displayId',
                'head_sort_status',
                'head_sort_categoryId'
            ]
                .filter(className => elm.hasClass(className))
                .map(it => it.replace('head_sort_', ''))[0]
            this.queryAsset.orderByDescending = false
            if (sorted || reverseSorted) {
                this.queryAsset.orderByDescending = reverseSorted ? false : true
            }
            this.queryAsset.orderBy = <QueryAssetOrderBy>sortName
            elm.addClass(this.queryAsset.orderByDescending ? 'sorttable_sorted_reverse' : 'sorttable_sorted')
            this.queryAndFillAssets()
        })
    }

    initUiElements() {
        super.initUiElements()
        this.searchPanel = $('.panel-content')
        this.listTableElm = $('#asset_mgt_list_table')
        this.cartTableElm = $('#asset_mgt_cart_table')
    }

    protected updateTablet(tablet: Tablet) {
        super.updateTablet.apply(this, arguments)
        this.takePictures()
        this.gotoStep(2)
        this.searchPanel.show()
    }

    protected processSignatureResult(signUrl: string) {
        super.processSignatureResult(signUrl)
        if (Object.keys(this.cartMap).length > 0) {
            this.toggleCartElms(true)
        }
    }

    private notifyAdded(){
        UiUtils.notify(3000, 'glyphicon-ok', '已加入借出清單', '<a href="#section_cart">查看</a>', 'location.href="#section_cart"')
    }
}

export class AssetItemElementCreator extends GeneralElementCreator {
    classId: string = 'asset_item'
}
export class LoanCartItemElementCreator extends GeneralElementCreator {
    classId: string = 'loan_cart_item'
}
export class LoanResultItemElementCreator extends GeneralElementCreator {
    classId: string = 'loan_item'
}